import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { getSubscriptionHistory } from "../../../../services/manager/signature.service";
import { ContentBody, ContentHeader } from "../../styled";
import { Col, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import { HistoryWrapper } from "./styles";
import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ISubscriptionDetails } from "../../../../models/ISubscriptionDetails";
import { StatusTag } from "../../components/table-subscriptions/styles";
import { formatDate } from "../../../../../helpers";
import moment from "moment";
import formatCurrency from "../../../../utils/formatCurrency";
import { getPlans } from "../../../../services/plans.service";

interface ISubscriptionHistory {}
export const SubscriptionHistory: React.FC<ISubscriptionHistory> = (props) => {
	const { t: translate } = useTranslation();
	const { id } = useParams<{ id: string }>();

	const history = useHistory();

	const [subHistory, setSubHistory] = useState<ISubscriptionDetails[]>([]);
	const [loading, setLoading] = useState(true);

	const [plans, setPlans] = useState([]);

	useEffect(() => {
		if (id) {
			setLoading(true);

			getSubscriptionHistory(id)
				.then((res) => {
					// incluir o campo totalValue para ordenacao na tabela
					setSubHistory(
						res.map((subscription: ISubscriptionDetails) => {
							const start = moment(subscription.start);
							const end = moment(subscription.end);
							const months = end.diff(start, "months");

							let totalValue = 0;

							if (months > 0) {
								totalValue = subscription.value * months;
							} else {
								totalValue = subscription.value;
							}

							return {
								...subscription,
								totalValue,
							};
						})
					);
				})
				.finally(() => {
					setLoading(false);
				});

			getPlans().then((res) => {
				setPlans(res);
			});
		}
	}, [id]);

	const planTemplate = (node: ISubscriptionDetails) => {
		if (node.plan) {
			const plan: any = plans.find((p: any) => p.id === node.plan);
			if (plan) {
				return <span>{plan.name}</span>;
			} else if (node.name) {
				return <span>{node.name}</span>;
			} else {
				return <span>-</span>;
			}
		}
	};

	const monthlyPriceTemplate = (node: ISubscriptionDetails) => {
		if (node.value) {
			return <span>{formatCurrency(node.value)}</span>;
		} else {
			return <span>-</span>;
		}
	};

	const totalPriceTemplate = (node: ISubscriptionDetails) => {
		if (node.value) {
			const start = moment(node.start);
			const end = moment(node.end);
			const months = end.diff(start, "months");

			if (months > 0) {
				return <span>{formatCurrency(node.value * months)}</span>;
			} else {
				return <span>-</span>;
			}
		} else {
			return <span>-</span>;
		}
	};

	const startDateTemplate = (node: ISubscriptionDetails) => {
		const date = formatDate(node.start);

		return <span>{date}</span>;
	};
	const endDateTemplate = (node: ISubscriptionDetails) => {
		const date = formatDate(node.end);
		return <span>{date}</span>;
	};

	/** Indica o status da assinatura, que pode ser Vigente, inativa, ou cancelada */
	function statusTemplate(node: ISubscriptionDetails) {
		const className =
			node.status === 1
				? "active"
				: node.status === 2
				? "inactive"
				: "canceled";

		const status =
			node.status === 1
				? "Vigente"
				: node.status === 2
				? "Inativa"
				: "Cancelada";

		return <StatusTag className={className}>{status}</StatusTag>;
	}

	const treeConfig = [
		{
			field: "id",
			header: "Nº",
			sortable: true,
			className: "id-column",
		},
		{
			field: "plan",
			header: "Plano",
			sortable: true,
			className: "name-column",
			body: planTemplate,
		},
		{
			field: "status",
			header: "Status",
			body: statusTemplate,
			sortable: true,
			className: "status-column",
		},
		{
			field: "value",
			header: "Valor mensal",
			body: monthlyPriceTemplate,
			sortable: true,
			className: "monthly-price-column",
		},
		{
			field: "totalValue",
			header: "Valor total",
			body: totalPriceTemplate,
			sortable: true,
			className: "total-price-column",
		},
		{
			field: "start",
			header: "Início",
			sortable: true,
			className: "start-column",
			body: startDateTemplate,
		},
		{
			field: "end",
			header: "Fim",
			sortable: true,
			className: "end-column",
			body: endDateTemplate,
		},
	];

	return (
		<HistoryWrapper>
			{/* Cabeçalho - Nome do usuário e voltar */}
			<ContentHeader>
				<Row>
					<Col>
						<OverlayTrigger
							placement="top"
							overlay={<Tooltip>{translate("back")}</Tooltip>}
						>
							<span>
								<HiOutlineArrowCircleLeft
									size={24}
									style={{
										marginRight: "10px",
										marginTop: "-10px",
										cursor: "pointer",
									}}
									className="mr-1 mb-1 cursor-pointer"
									onClick={() => history.goBack()}
								/>
							</span>
						</OverlayTrigger>
						<span className="title">Histórico de assinatura</span>
					</Col>
				</Row>
			</ContentHeader>

			<ContentBody>
				{loading ? (
					<div className="loading-container mt-5">
						<Spinner
							animation="border"
							variant="primary"
						/>
					</div>
				) : (
					<DataTable value={subHistory}>
						{treeConfig.map((col, index) => {
							return (
								<Column
									key={`col-${index}`}
									{...col}
								/>
							);
						})}
					</DataTable>
				)}
			</ContentBody>
		</HistoryWrapper>
	);
};
